(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jewellery-swatches"] && !Shopify.designMode) return;
  try {
    (function () {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      return;
    }

    function cardFor(bullet) {
      return bullet.closest('product-card') || bullet.closest('.product-card');
    }

    function primaryImageFor(card) {
      return card.querySelector('.product-card__image--primary');
    }

    document.addEventListener('mouseover', function (event) {
      if (!event.target.closest) return;
      var bullet = event.target.closest('.jewellery-swatches__bullet[data-swatch-image]');
      if (!bullet) return;
      var card = cardFor(bullet);
      if (!card) return;
      var img = primaryImageFor(card);
      if (!img) return;
      if (!img.dataset.jswOriginalSrc) {
        img.dataset.jswOriginalSrc = img.getAttribute('src') || '';
        img.dataset.jswOriginalSrcset = img.getAttribute('srcset') || '';
      }
      img.setAttribute('src', bullet.dataset.swatchImage);
      img.removeAttribute('srcset');
      card.classList.add('jewellery-swatches-hovering');
    });

    document.addEventListener('mouseout', function (event) {
      if (!event.target.closest) return;
      var bullet = event.target.closest('.jewellery-swatches__bullet[data-swatch-image]');
      if (!bullet) return;
      var next = event.relatedTarget;
      if (next && next.closest && next.closest('.jewellery-swatches__bullet[data-swatch-image]')) {
        return;
      }
      var card = cardFor(bullet);
      if (!card) return;
      var img = primaryImageFor(card);
      if (!img) return;
      if (img.dataset.jswOriginalSrcset) {
        img.setAttribute('srcset', img.dataset.jswOriginalSrcset);
      } else {
        img.removeAttribute('srcset');
      }
      if (img.dataset.jswOriginalSrc) {
        img.setAttribute('src', img.dataset.jswOriginalSrc);
      }
      card.classList.remove('jewellery-swatches-hovering');
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
